module.exports = __webpack_public_path__ + "media/images/responsive/lp/online/icon_number_02_yellow-c0961fea7ec56911cbd3e245ff4cfa52.svg";